import { createContext, useEffect, useState } from "react";

export const ThemeContext = createContext();

const ThemeProvider = ({ children }) => {
  const [isDark, setIsDark] = useState(true); // Default to dark mode

  useEffect(() => {
    // Check for saved theme preference or default to dark mode
    const savedTheme = localStorage.getItem("theme");

    if (savedTheme === "light") {
      setIsDark(false);
      document.documentElement.classList.remove("dark");
    } else {
      // Default to dark mode
      setIsDark(true);
      document.documentElement.classList.add("dark");
      if (!savedTheme) {
        localStorage.setItem("theme", "dark");
      }
    }
  }, []);

  const setTheme = (theme) => {
    const isDarkTheme = theme === "dark";
    setIsDark(isDarkTheme);

    if (isDarkTheme) {
      // document.documentElement.classList.add('dark');
      localStorage.setItem("theme", "dark");
    } else {
      // document.documentElement.classList.remove('dark');
      localStorage.setItem("theme", "light");
    }
  };

  return <ThemeContext.Provider value={{ isDark, setTheme }}>{children}</ThemeContext.Provider>;
};

export default ThemeProvider;
